import { Component, inject } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-date-range-picker',
  standalone: true,
  imports: [NgbDatepickerModule, FormsModule,CommonModule,MatDialogModule],
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss',
})
export class DateRangePickerComponent {
   // Storage keys
   private readonly STORAGE_KEY = 'dateRangePickerState';
  
  ranges = [
    { label: 'Last 15 days', days: 15 },
    { label: 'Last 30 days', days: 30 },
    { label: 'Last 90 days', days: 90 },
    { label: 'All time', from: { year: 2025, month: 1, day: 1 } },
    { label: 'Custom', days: null },
  ];
  calendar = inject(NgbCalendar);
  activeRange: string | null = 'Last 30 days';
  value ='';
  hoveredDate: NgbDate | null = null;
  constructor(private readonly dialogRef: MatDialogRef<DateRangePickerComponent>){
      // Initialize with default values first
      this.resetToDefaults();
    //this.value = this.getFormattedRange(this.calendar.getPrev( this.calendar.getToday(), 'd', 30),this.calendar.getToday());
    
  }
  
  fromDate: NgbDate | null = this.calendar.getPrev( this.calendar.getToday(), 'd', 30);
  toDate: NgbDate | null =this.calendar.getToday();


  get startDate(): NgbDate {
    const date = new Date();
    date.setMonth(date.getMonth() - 1); // Previous month
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, 1);
  }



  isHovered(date: NgbDate) {
    return (
      !this.isFutureDate(date) &&
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return (
      !this.isFutureDate(date) &&
      this.toDate &&
      date.after(this.fromDate) &&
      date.before(this.toDate)
    );
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isFutureDate(date: NgbDate): boolean {
    const today = this.calendar.getToday();
    return date.after(today);
  }

  public getFormattedRange(fromDate: NgbDate, toDate: NgbDate): string {
    const months = [
      '',
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'June',
      'July',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec',
    ];

    const format = (date: NgbDate): string =>
      `${date.day}/${months[date.month]}/${date.year}`;

    return `${format(fromDate)} - ${format(toDate)}`;
  }


  apply() {
    let val;
    if(this.fromDate !=null && this.toDate !=null){
      val = this.getFormattedRange(this.fromDate, this.toDate);
      this.dialogRef.close(val);
     // Output: "22/May/2025 – 1/June/2025"
      this.saveState();
    }
   
    
  }
  onClose(){
    this.dialogRef.close(null);
  }

  ngOnInit() {
    this.loadState();
  }

  private loadState() {
    try {
      const savedState = localStorage.getItem(this.STORAGE_KEY);
      if (savedState) {
        const state = JSON.parse(savedState);
        
        // Convert saved dates back to NgbDate objects
        if (state.fromDate) {
          this.fromDate = new NgbDate(
            state.fromDate.year,
            state.fromDate.month,
            state.fromDate.day
          );
        }
        
        if (state.toDate) {
          this.toDate = new NgbDate(
            state.toDate.year,
            state.toDate.month,
            state.toDate.day
          );
        }
        
        this.activeRange = state.activeRange;
        
        // Update the formatted value if we have both dates
        if (this.fromDate && this.toDate) {
          this.value = this.getFormattedRange(this.fromDate, this.toDate);
        }
      }
    } catch (e) {
      console.error('Failed to load state from localStorage', e);
      // Fall back to defaults if parsing fails
      this.resetToDefaults();
    }
  }

  private saveState() {
    if(this.fromDate !=null && this.toDate !=null){
    this.value = this.getFormattedRange(this.fromDate, this.toDate);
    }
    const state = {
      fromDate: this.fromDate,
      toDate: this.toDate,
      activeRange: this.activeRange,
      value:this.value
    };
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
  }

  private resetToDefaults() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 30);
    this.toDate = this.calendar.getToday();
    this.activeRange = 'Last 30 days';
    this.value = this.getFormattedRange(this.fromDate, this.toDate);
  }

  // Modify your existing methods to save state when changes occur
  selectRange(range: any) {
    this.activeRange = range.label;

    if (range.label === 'Custom') {
      this.fromDate = null;
      this.toDate = null;
    } else if (range.from) {
      this.fromDate = NgbDate.from(range.from);
      this.toDate = this.calendar.getToday();
    } else if (range.days) {
      this.toDate = this.calendar.getToday();
      this.fromDate = this.calendar.getPrev(this.toDate, 'd', range.days - 1);
    }
    
    //this.saveState();
  }

  onDateSelection(date: NgbDate) {
    // Prevent selection of future dates
    if (this.isFutureDate(date)) {
      return;
    }
  
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      this.activeRange = 'Custom';
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.activeRange = 'Custom';
    } else {
      this.toDate = null;
      this.fromDate = date;
      this.activeRange = 'Custom';
    }
    //this.saveState();
  }

  reset() {
    this.fromDate = null;
    this.toDate = null;
    this.activeRange = null;
    //this.saveState();
  }
}
